import React, { useState, useEffect } from 'react';
import { API_URL } from '../../utils/api'; // Fix import path relative to components/party
import PartyHost from './PartyHost';
import PartyPlayer from './PartyPlayer';

const PartyHome = ({ fetchWithAuth, user }) => {
    const [mode, setMode] = useState(null); // 'HOST' or 'PLAYER'
    const [joinPin, setJoinPin] = useState('');
    const [nickname, setNickname] = useState('');

    // Hosting State
    const [hostLobbyId, setHostLobbyId] = useState(null);
    const [hostPin, setHostPin] = useState(null);

    // Player State
    const [playerId, setPlayerId] = useState(null);

    // Check for PIN in URL parameters
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const pinFromUrl = urlParams.get('pin');
        if (pinFromUrl) {
            setJoinPin(pinFromUrl);
        }
    }, []);

    const handleCreateParty = async () => {
        try {
            const res = await fetchWithAuth(`${API_URL}/api/party/create/`, {
                method: 'POST'
            });
            const data = await res.json();
            if (data.success) {
                setHostPin(data.pin);
                setHostLobbyId(data.lobby_id);
                setMode('HOST');
            } else {
                alert('Error creating party: ' + data.error);
            }
        } catch (e) {
            console.error(e);
            alert('Failed to connect to server');
        }
    };

    const handleJoinParty = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/api/party/join/`, {
                method: 'POST',
                body: JSON.stringify({ pin: joinPin, nickname })
            });
            const data = await res.json();
            if (data.success) {
                setPlayerId(data.player_id);
                setMode('PLAYER');
            } else {
                alert('Error joining party: ' + data.error);
            }
        } catch (e) {
            console.error(e);
            alert('Failed to connect to server');
        }
    };

    if (mode === 'HOST') {
        return <PartyHost pin={hostPin} lobbyId={hostLobbyId} fetchWithAuth={fetchWithAuth} onExit={() => setMode(null)} />;
    }

    if (mode === 'PLAYER') {
        return <PartyPlayer playerId={playerId} pin={joinPin} nickname={nickname} onExit={() => setMode(null)} />;
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh] p-4">
            <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-plantlix-400 to-plantlix-500 mb-2">
                Plantlix Party
            </h1>
            <p className="text-gray-500 mb-8 text-lg">Multiplayer Pflanzen-Quiz</p>

            <div className="bg-white dark:bg-slate-800 p-8 rounded-2xl shadow-xl w-full max-w-md border border-slate-200 dark:border-slate-700">
                {/* HOST Option */}
                {user && (
                    <div className="mb-8 pb-8 border-b border-slate-200 dark:border-slate-700">
                        <h2 className="text-xl font-bold mb-4 dark:text-white">Spiel hosten</h2>
                        <button
                            onClick={handleCreateParty}
                            className="w-full py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-bold text-lg hover:shadow-lg transform active:scale-95 transition-all"
                        >
                            🚀 Neues Spiel starten
                        </button>
                        <p className="text-xs text-center mt-2 text-gray-400">Für größere Bildschirme empfohlen</p>
                    </div>
                )}

                {/* JOIN Option */}
                <div>
                    <h2 className="text-xl font-bold mb-4 dark:text-white">Spiel beitreten</h2>
                    <form onSubmit={handleJoinParty} className="space-y-4">
                        <input
                            type="text"
                            placeholder="z.B. 1234"
                            value={joinPin}
                            onChange={(e) => setJoinPin(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg bg-slate-700 border border-slate-600 focus:border-plantlix-500 focus:ring-2 focus:ring-plantlix-500/50 outline-none transition-all text-white font-mono text-2xl text-center tracking-widest"
                            maxLength="4"
                            required
                        />
                        <input
                            type="text"
                            placeholder="Dein Nickname"
                            value={nickname}
                            onChange={(e) => setNickname(e.target.value)}
                            className="w-full p-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 ring-plantlix-500/50 dark:text-white"
                            required
                        />
                        <button
                            type="submit"
                            className="w-full py-3 bg-plantlix-500 hover:bg-plantlix-600 text-white rounded-xl font-bold text-lg transition-colors"
                        >
                            Beitreten
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PartyHome;
